
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'

export default defineComponent({
    name: 'BaseModal',
    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['close'],
    setup (props, { emit, slots }) {
        const header = ref(slots.header)
        const footer = ref(slots.footer)

        const onKeyDown = (event: KeyboardEvent) => {
            switch (event.key) {
                case 'Escape':
                    event.preventDefault()
                    close()
            }
        }

        onMounted(() => {
            document.addEventListener('keydown', onKeyDown)
        })

        onUnmounted(() => {
            document.removeEventListener('keydown', onKeyDown)
        })

        const close = () => {
            emit('close')
        }

        return {
            header,
            footer,
            close
        }
    }
})
